import { render } from "./VImage.vue?vue&type=template&id=66d7000a&scoped=true"
import script from "./VImage.vue?vue&type=script&lang=js"
export * from "./VImage.vue?vue&type=script&lang=js"

import "./VImage.vue?vue&type=style&index=0&id=66d7000a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66d7000a"]])

export default __exports__